<template>
  <div class="row">
    <div class="col-md-12">
      <strong>
        {{ title }}
      </strong>
    </div>
    <div
      v-if="links.length"
      class="col-md-12 mt-2"
    >
      <ul class="links">
        <li
          v-for="(link, index) in links"
          :key="index"
        >
          <router-link-custom
            :to="link.to"
            :text="link.text"
            :status="link.status"
            :to_appid="link.to_appid"
            :current_appid="link.current_appid"
          />
        </li>
      </ul>
    </div>
    <div
      v-if="showCreateButton"
      class="col-md-12 mt-2"
    >
      <button
        class="btn btn-light btn-create"
        @click="handleCreate"
      >
        + {{ createButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: true,
    },
    links: {
      type: Array,
      required: true,
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    createButtonText: {
      type: String,
      default: true,
    },
  },

  methods: {
    handleCreate() {
      this.$emit('onCreate')
    },
  },
}
</script>

<style scoped>
.links {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSectionDocRefLink.vue